import { Box, LinearProgress } from "@mui/material";

export default function TopLoader({ loading }: any) {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 60,
        left: 0,
        width: "100%",
        zIndex: 10000,
      }}
    >
      <LinearProgress variant="indeterminate" />
    </Box>
  );
}
